module.exports = __webpack_public_path__ + "static/media/login-background.d7804370.jpg";